import { render, staticRenderFns } from "./CourseNew.vue?vue&type=template&id=ce33daa8"
import script from "./CourseNew.vue?vue&type=script&lang=js"
export * from "./CourseNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports